import { NextPage } from 'next';
import { GetEds } from '../../components/GetEds/GetEds';
import { useBreadcrumbs } from '../../components/_shared/Breadcrumbs/BreadcrumbsContext';

const getEdsPage: NextPage = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useBreadcrumbs([{ title: 'Электронная подпись' }]);

    return <GetEds />;
};

export default getEdsPage;
